export default "__VITE_ASSET__CE17oINU__"